export const lookupMapByKey = (list, key) => {
    return list.reduce((map, entity) => {
      const value = entity[key];
      if (value != null) {
        if (Array.isArray(value)){
          value.forEach((v) => {
            const cleanedValue = typeof v === 'string' ? v.replace(/\s+/g, '') : v;
            map[cleanedValue] = entity
          })
        } else {
          const cleanedValue = typeof value === 'string' ? value.replace(/\s+/g, '') : value;
          if (value === cleanedValue) {
            map[cleanedValue] = entity;
          } else {
            map[cleanedValue] = Object.assign({}, entity, { [key]: cleanedValue });
          }
        }
      }
      return map;
    }, {});
};

export const lookupMapById = function(list){
    return lookupMapByKey(list, 'id')
}

export const lookupItem = function(lookupMap, itemA, keyOrCallback){
    //match by Id
    const match = lookupMap[itemA.id] || itemA
    if(typeof keyOrCallback === 'string'){
        return match[keyOrCallback]
    }
    if(typeof keyOrCallback === 'function'){
        return keyOrCallback(match)
    }
    return match
}

/**
 * Returns a new array of objects, each containing only the specified properties.
 * Optionally sorts the resulting array using the provided sort method.
 *
 * @param {Array} list - The source array of objects.
 * @param {Array} props - The list of property names to pick from each object.
 * @param {Function} [sortMethod] - (Optional) The sorting function to apply to the result.
 * @returns {Array} A new array with objects containing only the selected properties.
 */
export const pickFields = function(list, props, sortMethod) {
  return Array.isArray(list)
    ? list.map(item => {
        let obj = {};
        props.forEach(p => obj[p] = item[p]);
        return obj;
      }).sort(sortMethod)
    : [];
}
export const cleanRouteInput = function (routeInput) {
  delete routeInput.checklistFeature
  delete routeInput.routeStatusHistory
  delete routeInput.rescuers
  delete routeInput.kudos
  delete routeInput.dailyLogs
  delete routeInput.device
  delete routeInput.vehicle
  delete routeInput.staff
  delete routeInput.accidentReport
  delete routeInput.document
  delete routeInput.injuryReport
  delete routeInput.helper
  delete routeInput.replaceByRoute
  delete routeInput.rescuer
  delete routeInput.messages
  delete routeInput.odometerReadings
  delete routeInput.vehicleDamage
  delete routeInput.isReplacement
  delete routeInput.parkingSpace
  delete routeInput.status
  delete routeInput.helperStatus
  delete routeInput.alignCellClassDevice
  delete routeInput.alignCellClassParkingSpace
  delete routeInput.alignCellClassRosterStatus
  delete routeInput.alignCellClassStaff
  delete routeInput.alignCellClassStaging
  delete routeInput.alignCellClassVehicle
  delete routeInput.driverCellClassHelper
  delete routeInput.driverCellClassStaff
  delete routeInput.driverCellClassVehicle
  delete routeInput.alignCellClassRoute
  delete routeInput.alignCellClassMessagesColumn
  delete routeInput.alignCellClassActionsColumn
  delete routeInput.odometersCount
  delete routeInput.dailyLogCount
  delete routeInput.dailyLogs
  delete routeInput.rescuersMapped
  delete routeInput.editMode
  delete routeInput.contentPopoverMissingPhotos
  delete routeInput.defaultDevicesByVehicle
  delete routeInput.defaultParkingSpaceByVehicle
  delete routeInput.dailyRoster
  delete routeInput.rosterChecklistSubjects
  delete routeInput.helperUpdatedDateTime
  delete routeInput.totalStops
  delete routeInput.totalPackages
  delete routeInput.completedStops
  delete routeInput.completedPackages
  delete routeInput.undeliveredPackagesTotal
  delete routeInput.undeliveredPackagesBusinessClose
  delete routeInput.undeliveredPackagesUnableToAccess
  delete routeInput.undeliveredPackagesOtherAWS
  delete routeInput.pickUpReturnPackage
  delete routeInput.additionalPackagesFromRescue
  delete routeInput.splitWithRosterAssignment
  delete routeInput.additionalPackagesFromSplit
  delete routeInput.firstStopTime
  delete routeInput.lastStopTime
  delete routeInput.daWorkStartTime
  delete routeInput.daWorkEndTime
  delete routeInput.daRouteStartTime
  delete routeInput.daRouteEndTime
  delete routeInput.rtsTime
  delete routeInput.lunchStartTime
  delete routeInput.lunchEndTime
  delete routeInput.inspectionFueled
  delete routeInput.inspectionCleaned
  delete routeInput.inspectionFlashers
  delete routeInput.inspectionCreditCard
  delete routeInput.inspectionKeys
  delete routeInput.inspectionDeviceCharger
  delete routeInput.inspectionDeviceBattery
  delete routeInput.inspectionNotes
  delete routeInput.requiredVehicleTypeString
  delete routeInput.expectedDurationHrs
  delete routeInput.lastBulkUploadDate
  delete routeInput.infractions
  delete routeInput.__typename
  return routeInput
}

export const cleanReplaceByRouteInput = function (routeInput) {
  delete routeInput.checklistFeature
  delete routeInput.device
  delete routeInput.vehicle
  delete routeInput.dailyRoster
  delete routeInput.staff
  delete routeInput.route
  delete routeInput.accidentReport
  delete routeInput.document
  delete routeInput.injuryReport
  delete routeInput.messages
  delete routeInput.odometerReadings
  delete routeInput.helper
  delete routeInput.parkingSpace
  delete routeInput.status
  delete routeInput.replaceByRouteStatusHistory
  delete routeInput.rosterChecklistSubjects
  delete routeInput.alignCellClassReplacementDevice
  delete routeInput.alignCellClassReplacementParkingSpace
  delete routeInput.alignCellClassReplacementRosterStatus
  delete routeInput.alignCellClassReplacementStaff
  delete routeInput.alignCellClassReplacementStaging
  delete routeInput.alignCellClassReplacementVehicle
  delete routeInput.driverCellClassReplacementHelper
  delete routeInput.driverCellClassReplacementStaff
  delete routeInput.driverCellClassReplacementVehicle
  delete routeInput.alignCellClassReplacementRoute
  delete routeInput.alignCellClassReplacementMessagesColumn
  delete routeInput.alignCellClassReplacementActionsColumn
  delete routeInput.driverCellClassReplacementDevice
  delete routeInput.odometersCount
  delete routeInput.dailyLogCount
  delete routeInput.dailyLogs
  delete routeInput.rescuersMapped
  delete routeInput.editMode
  delete routeInput.contentPopoverMissingPhotos
  delete routeInput.defaultDevicesByVehicle
  delete routeInput.defaultParkingSpaceByVehicle
  delete routeInput.statusChangedTime
  delete routeInput.previousStatus
  delete routeInput.__typename
  return routeInput
}
